import { useContext, useEffect } from 'react';
import { useMutation } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { EditStrategy } from 'services/apiServices';
import {
  EditUserStrategyParams,
  EditUserStrategyResult,
  Errors,
} from 'types/ApiServicesTypes';

export default function useEditUserStrategy(
  strategy_id: number,
  successCallback: (res?: EditUserStrategyResult, name?: string) => void,
) {
  const { showAlert } = useContext(ToastContext);
  const mutation = useMutation<
    EditUserStrategyResult,
    Errors,
    Pick<
    EditUserStrategyParams,
      'name' | 'sb_strategy' | 'strategy_id' | 'is_backtest' | 'is_favourite'
    >
  >('EditUserBot', values =>
    EditStrategy(strategy_id, values)
      .then(res => {
        if (!res || res.status_code !== 200 || res.error)
          showAlert!(
            res.error ? res.error : 'Something went wrong. Please try again.',
          );
        else successCallback(res, values.name);

        return res;
      })
      .catch(err => {
        showAlert!(err.message as string);
        return err;
      }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
}
